export enum FrontCfgEnum {
  LiveChatConfig = "LiveChatConfig",
}
